export const CarouselDotsClasses = {
  DOTS_ROUNDED: ['wf-h-2', 'wf-w-2', 'wf-rounded-full', 'focus:wf-outline-none'],
  DOTS_SQUARE: ['wf-h-2', 'wf-w-2', 'focus:wf-outline-none'],
  DOTS_LINE: ['wf-h-1', 'wf-w-12', 'focus:wf-outline-none']
}